<template>
  <div class="contact-card-single">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />

    <Review-Popup
      v-if="showReviewPopup"
      v-on:reviewPopupClosed="showReviewPopup = false"
    />
    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />
    <Credit-Limit-Popup
      v-if="showCreditLimitPopup"
      v-on:clickedOutside="showCreditLimitPopup = false"
    />
    <div v-if="profileData == null" class="custom-form-section">
      <div class="custom-domain-text">Find anybody's email with a click</div>
      <form
        v-on:submit.prevent="customWebsiteSubmit"
        class="form-section"
        ref="formDomain"
      >
        <Input-With-Label
          ref="firstName"
          :autocomplete="'off'"
          :type="'text'"
          :required="'true'"
          :id="'firstName'"
          :placeholder="'First Name'"
        />
        <Input-With-Label
          ref="lastName"
          :autocomplete="'off'"
          :type="'text'"
          :id="'lastName'"
          :pattern="'(.+)'"
          :required="'true'"
          :placeholder="'Last Name'"
        />
        <Input-With-Label
          ref="domain"
          :autocomplete="'off'"
          :type="'text'"
          :required="'true'"
          :id="'domain'"
          :pattern="'(.+[.?].+)'"
          :title="'Please enter valid domain'"
          :placeholder="'Company Domain'"
        />
        <div class="btn-section d-flex">
          <input :class="'btn-blue'" :value="'Get Contact'" :type="'submit'" />
        </div>
      </form>
    </div>
    <template v-else>
      <Single-Contact-Card
        :loading="loading"
        :profileData="profileData"
        :companyData="companyData"
        :loadingCompany="loadingCompany"
        :error="errorMsg"
        :dataLoadingInBg="false"
      />
    </template>
  </div>
</template>

<script>
import SingleContactCard from '@/components/linkedin/SingleProfile/SingleContactCard.vue'
import UpgradePopup from '@/components/UpgradePopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import sharedFunctions from '@/assets/util/functions.js'
import { post, get } from '@/assets/util/rest.js'
import { advanceSearchUrl } from '@/assets/util/constants/constants.js'
import InputWithLabel from '@/components/InputWithLabel'

export default {
  name: 'CustomWebsiteContactCard',
  watch: {
    error: {
      handler(newValue, oldValue) {
        if (oldValue != newValue) {
          this.errorMsg = newValue
        }
      }
    },
    profileData: {
      handler() {
        this.errorMsg = { msg: null }
      }
    }
  },
  data: function() {
    return {
      trySMPT: false,
      addButtonLoading: false,
      smtpCompleted: false,
      showPopup: false,
      showCreditLimitPopup: false,
      errorMsg: {
        msg: null
      },
      upgradePopupType: null,
      showReviewPopup: false,
      showActivationPopup: false,
      loading: false,
      companyData: null,
      profileData: null,
      loadingCompany: false
    }
  },
  computed: {
    isContactOwned: function() {
      const id = this.profileData.linkedinId
      return this.$store.state.linkedin.bulk.contacts[id].contactAlreadyOwned
    }
  },
  components: {
    'Upgrade-Popup': UpgradePopup,
    'Review-Popup': ReviewPopup,
    'Activation-Popup': ActivationPopup,
    'Input-With-Label': InputWithLabel,
    'Credit-Limit-Popup': CreditLimitPopup,
    'Single-Contact-Card': SingleContactCard
    // 'Crm-Export': CrmExport,
    // 'Crm-Export-Loader': CrmExportLoader
  },
  methods: {
    updateEmail(res) {
      this.profileData.email = res.email
      this.profileData.phone = res.phone
      this.profileData.mcId = res.masterContactId
      this.profileData.contactAlreadyOwned = true
    },
    findEmailSmtp() {
      const filteredData = sharedFunctions.getFilteredData(this.profileData)
      this.findEmail(filteredData)
    },
    findEmailWithCustomDomain(inputData) {
      this.profileData.domain = inputData.domain
      this.profileData.companyName = inputData.companyName
      this.profileData.title = null
      this.profileData.level = null
      this.profileData.email = null
      this.profileData.phone = null
      this.profileData.department = null
      this.companyData = null
      this.errorMsg.msg = null
      let customData = {}
      customData.fullName = this.profileData.fullName
      customData['experience'] = [
        {
          isVerifiedDomain: false,
          isActivelyWorking: true,
          domain: inputData.domain,
          companyName: inputData.companyName
        }
      ]
      this.findEmail(customData)
    },
    doNothing() {},
    getLevelNameFromLevel(level) {
      let levelName = null
      if ('C-Level' === level || 'VP-Level' === level) {
        levelName = 'Decision maker'
      } else if ('Director-Level' === level) {
        levelName = 'Influencer'
      } else if ('Manager-Level' === level) {
        levelName = 'Champion'
      } else {
        levelName = level
      }
      return levelName
    },
    canShowCRMButton() {
      return (
        this.profileData &&
        this.profileData.email &&
        this.profileData.contactAlreadyOwned == true
      )
    },
    canShowButton() {
      return (
        this.profileData.domain &&
        (!this.profileData.email || this.profileData.email.indexOf('*') != -1)
      )
    },
    findEmail(data) {
      if (data) {
        this.loading = true
        let that = this
        post('lp/email.htm', data)
          .then(response => {
            setTimeout(function() {
              if (response.status == 200) {
                response.json().then(res => {
                  if (res.statusCode == '200') {
                    that.profileData = {
                      ...res.response,
                      phone:
                        res.response && res.response.phoneNumberFromVendor
                          ? res.response.phoneNumberFromVendor
                          : null,
                    }
                    that.profileData.contactAlreadyOwned = true
                    let companyId =
                      res.response && res.response.companyId
                        ? res.response.companyId
                        : ''
                    if (companyId != '') {
                      that.getCompanyData(companyId)
                      // that.getContactCount(companyId)
                    }
                  } else if (res.statusCode == '400') {
                    that.showActivationError()
                  } else if (res.statusCode == '402') {
                    that.showUpgradePopup('views')
                  } else if (res.statusCode == '420') {
                    that.setShowCreditLimitPopup()
                  } else {
                    that.profileData ? (that.profileData.email = null) : ''
                    console.log('respons msgs :' + res)
                    if (res.error && res.error[0] && res.error[0].code) {
                      that.errorMsg = that.getErrorMsg(res)
                    } else {
                      that.errorMsg = { msg: res.errorMessage }
                    }
                  }
                })
              }
              that.loading = false
            }, 2000)
          })
          .catch(e => {
            that.loading = false
            console.log('error: ' + e)
          })
      }
    },
    copyClipboard(cId, mail, name) {
      if (!this.canShowButton()) {
        let txtDisplay = 'Copied'
        const dataMap = {
          pageType: 'Try Different Domain'
        }
        sharedFunctions.clickToCopy(
          cId,
          mail,
          name,
          null,
          dataMap,
          txtDisplay,
          this.$store.state
        )
      }
    },
    showAllOtherContact(e) {
      let domain =
        e && e.currentTarget ? e.currentTarget.getAttribute('data-link') : ''
      if (domain != '')
        window.open(
          advanceSearchUrl(domain, this.$store.state.header.uiVersion)
        )
    },
    getErrorMsg(res) {
      return sharedFunctions.getRespectiveErrorMsg(res)
    },
    salesForceSuccess(res) {
      console.log('salesForceSuccess ', res)
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    showActivationError() {
      this.showActivationPopup = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    getCompanyData(compId) {
      this.loadingCompany = true
      get('lp/getCompany.htm?id=' + compId)
        .then(response => {
          this.loadingCompany = false
          if (response.status == 200) {
            response
              .json()
              .then(res => {
                console.log('comapny data ', res)
                this.companyData = res
                //console.log('data: ' + JSON.stringify(res))
              })
              .catch(e => {
                this.loadingCompany = false
                console.log('err: ' + e)
              })
          } else {
            this.loadingCompany = false
            console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          this.loadingCompany = false
          console.log('error: ' + e)
        })
    },
    // getContactCount(compId) {
    //   get('lp/company/' + compId + '/contactCount.htm')
    //     .then(response => {
    //       if (response.status == 200) {
    //         response
    //           .json()
    //           .then(res => {
    //             console.log('contact count ', res)
    //             this.conatactCount = res
    //             //console.log('data: ' + JSON.stringify(res))
    //           })
    //           .catch(e => {
    //             console.log('err: ' + e)
    //           })
    //       } else {
    //         console.log('status: ' + response.status)
    //       }
    //     })
    //     .catch(e => {
    //       console.log('error: ' + e)
    //     })
    // },
    formatLocationString(street, city, state, country) {
      let str = ''
      str = str + (street ? street + (city ? ', </br> ' : '') : '')
      str = str + (city ? city + (state ? ',</br> ' : '') : '')
      str = str + (state ? state + (country ? ', </br>' : '') : '')
      str = str + (country ? country + '' : '')
      return str
    },
    customWebsiteSubmit() {
      this.profileData = {}
      let firstName = this.$refs.firstName.$refs.input.value
      let lastName = this.$refs.lastName.$refs.input.value
      let domain = this.$refs.domain.$refs.input.value

      this.profileData.fullName = firstName + ' ' + lastName
      const inputData = {
        domain: domain,
        companyName: ''
      }
      console.log('dataMap ', inputData)
      this.findEmailWithCustomDomain(inputData)
    }
  },
  created() {
    sharedFunctions.track(
      'AP - Custom Find Email Section Shown',
      null,
      this.$store.state
    )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.custom-form-section {
  padding: 16px;
  .custom-domain-text {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 30px;
  }
  .form-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .btn-section::v-deep {
      overflow: hidden;
      margin-top: 10px;
      input {
        width: 90px;
        padding: 10px 0px;
        font-size: 14px;
        border-radius: 6px;
        border: 0;
        background-color: $primary-color;
        color: $white;
        width: 100%;
        cursor: pointer;
        &:hover {
          background-color: lighten($primary-color, 5%);
        }
      }
    }
  }
}
</style>
